/**
 * @file: ReportShareTarget.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ReportShareTarget {
  Customer = 1,
  ServiceAgent = 2,
}

export const ReportShareTargetValueSet = new Set([
  ReportShareTarget.Customer,
  ReportShareTarget.ServiceAgent,
]);
